import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Stack,
  TextField,
} from "@mui/material";

function AddVideoDialog({ open, onClose, values, setValues, adding, onSubmit }) {
  return (
    <Dialog
      open={open}
      onClose={() => (adding ? null : onClose)}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Add Video</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="Title"
            value={values.title}
            onChange={(e) =>
              setValues((v) => ({ ...v, title: e.target.value }))
            }
            fullWidth
          />
          <TextField
            label="YouTube URL"
            value={values.url}
            onChange={(e) => setValues((v) => ({ ...v, url: e.target.value }))}
            fullWidth
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={adding}>
          Cancel
        </Button>
        <Button variant="contained" disabled={adding} onClick={onSubmit}>
          {adding ? <CircularProgress size={18} sx={{ color: "#fff" }} /> : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddVideoDialog;
